import { getTrackingUrl } from '@xing-com/crate-entity-pages-common/tracking';

import { CompanyRecommendationCardSkeleton } from './company-recommendation-card.skeleton';
import * as Styled from './company-recommendation-card.styles';

type Props = {
  profileName: string;
  link?: string;
  backgroundImageUrl?: string;
  profileImage?: string;
};

export const CompanyRecommendationCard: React.FC<Props> & {
  Skeleton: typeof CompanyRecommendationCardSkeleton;
} = ({ profileImage, backgroundImageUrl, profileName, link }: Props) => {
  return (
    <Styled.CardWrapper>
      <Styled.Card
        href={getTrackingUrl({
          to: link,
          trackingKey: 'viewCompanyRecommendation',
        })}
        linkProps={{
          'aria-label': profileName + ' link',
        }}
      >
        <Styled.ProfileBackground
          style={
            backgroundImageUrl
              ? { backgroundImage: `url(${backgroundImageUrl}) ` }
              : {}
          }
        >
          <Styled.ProfileImage
            size="large"
            type="company"
            profileName="xing"
            src={profileImage}
          />
        </Styled.ProfileBackground>
        <Styled.Headline fontWeight="bold" lineHeight="dense" size={'large'}>
          {profileName}
        </Styled.Headline>
      </Styled.Card>
    </Styled.CardWrapper>
  );
};

CompanyRecommendationCard.Skeleton = CompanyRecommendationCardSkeleton;
